/* tslint:disable */
/* eslint-disable */
export enum AddressFormatType {
  Legacy = 'LEGACY',
  City = 'CITY'
}
